execOptionsRef